'use client'

export default function imageLoader({ src, width, quality } : any) {
  try {
    const inputUrl = new URL(src);
    const host = inputUrl.host.toLowerCase();
    const pathname = inputUrl.pathname;
    const queryStr = inputUrl.search;

    const separator = queryStr ? '&' : '?';

    const outputUrl = src.endsWith('svg')
      ? src // minimally process svgs; fallback in case unoptimized prop is not passed to Image component
      : host === 'images.contentstack.io' || host.includes('schumacherhomes.com') // handle contentstack imgs or static imgs
      ? `https://${host}${pathname}?format=webp&width=${width}&quality=${quality}`
      : `${src}${separator}w=${width}&q=${quality || 75}`; // Default Next.js behavior;
    return outputUrl;
  } catch { // defensively handle cases where src is a reference to a local file (eg placeholder svg)
    return src
  }
}
